export const PATIENT_FORM_OBJECT_CATEGORIES = ['group', 'checkbox', 'date', 'header', 'number', 'select', 'text'] as const;

export type PatientFormObjectCategories = typeof PATIENT_FORM_OBJECT_CATEGORIES[number];